import { RouteLocationNormalized } from "vue-router";
import router from "./router";

router.afterEach((to: RouteLocationNormalized) => {
  if (to.fullPath !== '/') {
    window.scrollTo(0, 0)
  }
  document.title = (to.meta.title as string) ;
});
